import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  TextField,
  FormControl, Chip,
  InputLabel
} from '@material-ui/core'
import Downshift from 'downshift'

const FormTagsField = ({ formActions, classes, name, labelKey, label, required, tags, onBlurFn, row, singleRow, small, large }) => {
  const intl = useIntl()
  const [inputValue, setInputValue] = React.useState('')
  const [selectedItem, setSelectedItem] = React.useState([])

  React.useEffect(() => {
      if (!!tags) {
        setSelectedItem(tags)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [tags])

  React.useEffect(() => {
      formActions.setFieldValue(name, selectedItem)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedItem])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      const newSelectedItem = [...selectedItem]
      const duplicatedValues = newSelectedItem.indexOf(
        event.target.value.trim()
      )

      if (duplicatedValues !== -1) {
        setInputValue('')
        return
      }
      if (!event.target.value.replace(/\s/g, '').length) return

      newSelectedItem.push(event.target.value.trim())
      setSelectedItem(newSelectedItem)
      setInputValue('')
    }
    if (
      selectedItem.length &&
      !inputValue.length &&
      event.key === 'Backspace'
    ) {
      setSelectedItem(selectedItem.slice(0, selectedItem.length - 1))
    }
  }

  const handleChange = (item) => {
    let newSelectedItem = [...selectedItem]
    if (newSelectedItem.indexOf(item) === -1) {
      newSelectedItem = [...newSelectedItem, item]
    }
    setInputValue('')
    setSelectedItem(newSelectedItem)
  }

  const handleDelete = item => () => {
    const newSelectedItem = [...selectedItem]
    newSelectedItem.splice(newSelectedItem.indexOf(item), 1)
    setSelectedItem(newSelectedItem)
  }

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : '',
    !!singleRow ? classes.SingleRow : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel htmlFor={name}>{label ?? <FormattedMessage id={labelKey}/>}{!!required &&
      <span className={'required'}>*</span>}: </InputLabel>
      <FormControl variant="outlined" className={'has-downshift'}>
        <Downshift
          id="downshift-multiple"
          inputValue={inputValue}
          onChange={handleChange}
          selectedItem={selectedItem}
        >
          {({ getInputProps }) => {
            const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
              onKeyDown: handleKeyDown,
              placeholder: label ?? intl.formatMessage({ id: labelKey })
            })
            return (
              <div>
                <TextField
                  required={required}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  InputProps={{
                    startAdornment: selectedItem.map(item => (
                      <Chip
                        key={item}
                        tabIndex={-1}
                        label={item}
                        className={classes.chip}
                        onDelete={handleDelete(item)}
                      />
                    )),
                    onBlur,
                    onChange: event => {
                      handleInputChange(event)
                      onChange(event)
                    },
                    onFocus
                  }}
                  onBlur={(e) => {
                    !!onBlurFn && onBlurFn(e)
                    formActions.handleBlur(e)
                  }}
                  helperText={formActions.errors[name] && formActions.touched[name] && formActions.errors[name]}
                  error={formActions.errors[name] && formActions.touched[name] !== undefined}
                  {...inputProps}
                />
              </div>
            )
          }}
        </Downshift>
      </FormControl>
    </div>
  )
}

export default FormTagsField
